"use client";
import CommonButton from "@/components/CommonButton";
import CommonInput from "@/components/CommonInput";
import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import moneyImage from "../../public/assets/images/find-quote/get-quote-by-id-img.png";
import * as Yup from "yup";
import Image from "next/image";
import { Formik } from "formik";
import { showToast } from "../../utils/libs/toast-utilis";
import { findQuoteById } from "@/services/pricing";
import { useRouter } from "next/navigation";
import { event } from "@/lib/analytics";

const GetQuoteById = () => {
  const [formData, setFormData] = useState({
    email: null,
    quoteId: null,
  });
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const validationSchema = Yup.object().shape({
    quoteId: Yup.string().required("Quote Id is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
  });
  const handleSubmit = async (values) => {
    setFormData(values);
    setLoading(true);
    try {
      const res = await findQuoteById({
        quoteID: values?.quoteId.replace(/^#*/, ""),
        email: values?.email,
      });
      event({
        action: "Get Quote by Id",
        params: {
          page: "find_quote",
          quoteId: values?.quoteId ,
        },
      });
      localStorage.setItem("authDetails", JSON.stringify(res?.users));
      router.replace(`/project-price?quoteId=${res?.lead?._id}`);
    } catch (error) {
      if (error.message) {
        showToast.error(error.message);
      }
      setLoading(false);
    }
  };
  return (
    <section className="get-quote-section">
      <Container fluid>
        <Row className="align-items-center gy-4">
          <Col md={6} lg={6}>
            <div className="form-wrapper">
              <h3>Hey there 👋</h3>
              <p>
                Let’s pick up where you left off. Enter your details to view
                your quote.
              </p>
              <Formik
                initialValues={formData}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({
                  handleSubmit,
                  handleChange,
                  setFieldValue,
                  handleBlur,
                  values,
                  errors,
                  touched,
                }) => (
                  <form onSubmit={handleSubmit} className="get-quote-form">
                    <Row className="gy-2">
                      <Col sm={12}>
                        <CommonInput
                          label="Email"
                          name="email"
                          placeholder="Example@email.com"
                          value={values.email ?? ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.email && errors.email}
                        />
                      </Col>
                      <Col sm={12}>
                        <CommonInput
                          label="Quote ID"
                          name="quoteId"
                          placeholder="#NVC-Q00064"
                          value={values.quoteId ?? ""}
                          onChange={(e) => {
                            const inputValue = e.target.value;
                            const normalizedValue = inputValue.startsWith("#")
                              ? inputValue
                              : "#" + inputValue.replace(/^#*/, "");

                            setFieldValue("quoteId", normalizedValue);
                          }}
                          onBlur={handleBlur}
                          error={touched.quoteId && errors.quoteId}
                        />
                      </Col>
                      <Col sm={12}>
                        <CommonButton
                          label="Get Quote"
                          type="submit"
                          disabled={loading}
                          className="btn-primary GetQuoteByIdButton w-100"
                          icon={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 448 512"
                              style={{ height: "20px", fill: "#fff" }}
                            >
                              <path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" />
                            </svg>
                          }
                        />
                      </Col>
                    </Row>
                  </form>
                )}
              </Formik>
            </div>
          </Col>
          <Col md={6} lg={6} className="text-center">
            <div className="get-quote-image">
              <Image
                src={moneyImage}
                alt="Money illustration"
                className="img-fluid"
                width={400}
                height={400}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default GetQuoteById;
